import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import QuotationIcon from 'images/organization/homepage/sections/whatPeopleSay/quotation-logo.svg'
interface TestimonialData {
  name: string
  testimonial: string
}

const CarouselCard = ({ name, testimonial }: TestimonialData): ReactElement => {
  return (
    <Flex
      sx={{
        borderRadius: '1.2rem',
        border: '1px solid',
        borderColor: 'blueYonder20',
        backgroundColor: 'white',
        background:
          'linear-gradient(0deg, rgba(6, 13, 30, 0.8), rgba(6, 13, 30, 0.8)), linear-gradient(0deg, rgba(92, 109, 150, 0.2), rgba(92, 109, 150, 0.2))',
        py: '4rem',
        px: '3.2rem',
        mx: '1.6rem',
        width: '36rem',
        height: '32rem',
        flexDirection: 'column',
        justifyContent: 'center',
        flexShrink: 0,
        color: 'lightSteelBlue',
        gap: 'auto',
      }}
    >
      <Svg
        sx={{ flexShrink: 0, mb: '2.4rem' }}
        svg={QuotationIcon}
        descriptiveText="Quotation mark icon for testimonial"
      ></Svg>
      <Text
        sx={{
          fontSize: '1.4rem',
          fontStyle: 'italic',
          fontWeight: '400',
          textAlign: 'left',
        }}
      >
        {testimonial}
      </Text>
      <Flex
        sx={{
          alignItems: 'center',
          mt: 'auto',
          gap: '0.3rem',
        }}
      >
        <Flex>
          <Flex
            sx={{
              alignItems: 'center',
              gap: '1.2rem',
              pt: '1.2rem',
            }}
          >
            <Flex
              sx={{
                border: '1px solid',
                borderColor: 'rgba(201, 102, 255, 0.20)',
                backgroundColor: 'rgba(201, 102, 255, 0.10)',
                borderRadius: 100,
                width: '3.2rem',
                height: '3.2rem',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(201, 102, 255, 0.90)',
              }}
            >
              {name.slice(0, 1)}
            </Flex>
            <Text>{name}</Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CarouselCard
